import React from 'react';
import Select from "react-select";
import {SelectDropdownIndicator, selectStyles} from "components/componentsForm/selectStyles";

const MonoSelect = ({
    data,
    selectArray,
    defaultValue,
    placeholder = "Sélectionner une qualification",
    noOptionsMessage = "Sélectionnez le secteur d'activité",
    ariaLabel,
}) => {

    function extract(data) {
        let options = []
        data.map((d) => {
                if(d.name){
                    options.push({value: d.name , label: d.name})
                }else{
                    options.push({value: d.IDCC_id, label: d.IDCC_name})
                }
        }
        )
        return options
    }
    const handleT = (selected) => {
        selectArray(selected)
    }
    const result = extract(data)
    
    const selectedValue = defaultValue ? result.find(opt => opt.value === defaultValue) : null

    return (
        <>
            <Select
                closeMenuOnSelect={true}
                onChange={handleT}
                value={selectedValue}
                options={result}
                placeholder={placeholder}
                styles={selectStyles}
                // Same as MultiDdl: on document.body so that the fixed footer of the wizards (z-20)
                // never covers the menu, opening upwards when there is no room below.
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="absolute"
                menuPlacement="auto"
                menuShouldScrollIntoView={false}
                components={{DropdownIndicator: SelectDropdownIndicator}}
                classNamePrefix="react-select"
                noOptionsMessage={() => noOptionsMessage}
                aria-label={ariaLabel}
            />
        </>
    );
};

export default MonoSelect;